export default "__VITE_ASSET__14e52b10__"